import { ScriptData } from '@data/models/amplify';
import { apiCall } from '../axios';
import { getAmplifyMetasearchConnectorServiceApi, getMarketingInsightServiceApi, } from '../../../config';
export class AmplifyService {
    static getScriptData(host, params) {
        return new Promise((resolve, reject) => {
            const url = `${host}/scripts/getScriptData`;
            apiCall(ScriptData)('post', url, params)
                .then((res) => {
                resolve(res);
            })
                .catch(reject);
        });
    }
    static getScriptDataFromAMCS(params) {
        return AmplifyService.getScriptData(getAmplifyMetasearchConnectorServiceApi(), params);
    }
    static getScriptDataFromMIS(params) {
        return AmplifyService.getScriptData(getMarketingInsightServiceApi(), params);
    }
}
